import React from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ComingSoonBanner from '../components/ComingSoonBanner';

const Music = () => {
  const { user } = useAuth();

  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              🎵 Módulo de Música
            </h1>
            <p className="text-gray-600 dark:text-gray-300">
              Genera música original con inteligencia artificial
            </p>
          </div>

          <ComingSoonBanner
            title="Módulo de Música - Próximamente"
            description="Este módulo está siendo configurado con las mejores plataformas de generación de música con IA. Pronto podrás crear música original, soundtracks, composiciones personalizadas y covers con inteligencia artificial."
            estimatedDate="Enero 2025"
          />

          <div className="bg-white dark:bg-[#1a2530] rounded-xl p-6 shadow-sm">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              Características Próximas
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🎼 Composición Original</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Crea música original en cualquier género con descripción de texto
                </p>
              </div>
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🎬 Soundtracks</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Genera música de fondo perfecta para videos y contenido
                </p>
              </div>
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🎸 Covers con IA</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Crea covers y remixes de canciones con inteligencia artificial
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default Music;